/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import Filter from './Filter/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsPostPayment/Content/AccountSelect/Content",
  isInvalid,
  isSubmitting
  
}) {
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let paymentAccountsValueData = fromData.useDataValue({ viewPath,
context: 'payment_accounts',
})
let paymentsPostPaymentPayorFilterValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'payor_filter',
})
let aggregateData = fromHelpers.filterPaymentAccounts(paymentAccountsValueData, paymentsPostPaymentPayorFilterValueData)
let paymentsPostPaymentPaymentAccountSelectedIdValueData = fromData.useDataValue({ viewPath,
context: 'payments_post_payment',
path: 'payment_account.selected_id',
})
let paymentsPostPaymentPaymentAccountSelectedIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'payments_post_payment',
path: 'payment_account.selected_id',
validate: fromValidate.textInputOrNumber,
required: true,
})
let paymentsPostPaymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payments_post_payment',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  isInvalid,
  isSubmitting
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Payor account"
 color={dtColorsNeutral900}
 size="normal"
 weight="medium"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
/>
<Filter
  viewPath={`${viewPath}/Filter`}
/>
</div>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 isMultiChoice={false}
 onChange={onChange}
 data="payment_accounts"
 data="payments_post_payment.payor_filter"
 aggregate="helpers.js filterPaymentAccounts"
 from={aggregateData}
 data="payments_post_payment.payment_account.selected_id"
 validate="/Data/validate.js textInputOrNumber"
 required={true}
 value={paymentsPostPaymentPaymentAccountSelectedIdValueData}
 invalid={!paymentsPostPaymentPaymentAccountSelectedIdIsValidData}
 data="payments_post_payment"
 disabled={paymentsPostPaymentIsSubmittingData}
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
</div>
{children}
</React.Fragment>)
}